const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/members/invite/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { validateInviteMembersQueryParams } from "@/react/components/SettingsApp/ManageMembers/InviteMembers/queryParamsSchema";
import { INVITE_TAB, INVITE_TAB_PATHS } from "@/react/components/SettingsApp/ManageMembers/InviteMembers/Tabs/DetailsTab/components/constants";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/members/invite/")({
  beforeLoad: ({
    location
  }) => {
    redirect({
      to: INVITE_TAB_PATHS[INVITE_TAB.DETAILS],
      replace: true,
      search: validateInviteMembersQueryParams,
      state: location.state,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});